import React, { useEffect } from "react";
import { Box, Avatar, Typography, Grid } from "@mui/material";
import { getTeamPublicView } from "../../services/ProjectApi";
import { useParams, useNavigate } from "react-router-dom";
import { Workspaces } from "@mui/icons-material";

const TeamPublicView = () => {
  const [teamMebers, setTeamMebers] = React.useState({
    Cast: [],
    Crew: [],
    "Support & Production": [],
  });
  const { projectId } = useParams();
  const navigate = useNavigate();

  console.log("teamMebers", teamMebers);

  useEffect(() => {
    const fetchTeamData = async () => {
      try {
        const response = await getTeamPublicView(projectId);
        setTeamMebers(response.data);
      } catch (error) {
        console.error("Error fetching team data:", error);
      }
    };
    fetchTeamData();
  }, [projectId]);

  // Helper function to render a section (cast, crew, support & production)
  const renderSection = (sectionData, sectionTitle) => {
    if (sectionData.length === 0) return null; // Skip rendering if no users

    return (
      <Box sx={{ mb: 2, padding: 1 }}>
        <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
          <Box
            sx={{ width: 6, height: 25, backgroundColor: "#E90000", mr: 1 }}
          />
          <Typography
            variant="h5"
            component="h5"
            sx={{ fontWeight: "bold", textTransform: "capitalize" }}
          >
            {sectionTitle}{" "}
            <Typography component="span" variant="h4" sx={{ color: "#1976D2" }}>
              {sectionData.length > 20 ? "20+" : " "}
            </Typography>
          </Typography>
        </Box>
        <Grid container spacing={3}>
          {sectionData.map((member, index) => (
            <Grid size={{ xs: 12, sm: 6, md: 4}} key={index}>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 2,
                  cursor: "pointer",
                  p: 1,
                  borderRadius: 1,
                  transition: "all 0.2s",
                  "&:hover": {
                    backgroundColor: "rgba(0, 0, 0, 0.04)",
                    transform: "translateY(-2px)",
                  },
                }}
                onClick={() => navigate(`/profile/${member.username}`)}
              >
                <Avatar
                  src={member.thumbnail_url}
                  alt={member.Name}
                  sx={{ 
                    width: 70, 
                    height: 70,
                    flexShrink: 0
                  }}
                />
                <Box
                  sx={{
                    flex: 1,
                    minWidth: 0, 
                  }}
                >
                  <Typography
                    variant="subtitle1"
                    component="h3"
                    sx={{ 
                      fontWeight: 600,
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                    }}
                    title={member.Name} // Shows full name on hover
                  >
                    {member.Name}
                  </Typography>

                  <Typography 
                    variant="body2" 
                    sx={{
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                      color: "text.secondary"
                    }}
                    title={member.role_name} // Shows full role on hover
                  >
                    {member.role_name}
                  </Typography>
                  
                  <Typography 
                    variant="caption" 
                    color="text.secondary"
                    sx={{
                      fontSize: "0.75rem",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                    }}
                  >
                    Joined:{" "}
                    {member.joined_at
                      ? new Date(member.joined_at)
                        .toLocaleDateString("en-GB", {
                          day: "2-digit",
                          month: "short",
                          year: "numeric",
                        })
                        .replace(/ /g, " ")
                      : "N/A"}
                  </Typography>
                </Box>
              </Box>
            </Grid>
          ))}
        </Grid>
      </Box>
    );
  };

  return (
    <Grid size={{ xs: 12 }}>
      <Typography 
        variant="h5" 
        fontWeight={600}
      >
        Team Members
      </Typography>

      {teamMebers.Cast.length === 0 &&
        teamMebers.Crew.length === 0 &&
        teamMebers["Support & Production"].length === 0 ? (
        <Typography
          variant="body1"
          color="text.secondary"
          sx={{ 
            display: "flex", 
            alignItems: "center", 
            mt: 2,
            textAlign: "center",
            width: "100%",
            justifyContent: "center",
            py: 4
          }}
        >
          No Team Member Added till now.
        </Typography>
      ) : (
        <>
          {renderSection(teamMebers.Cast, "cast")}
          {renderSection(teamMebers.Crew, "crew")}
          {renderSection(
            teamMebers["Support & Production"],
            "support & production"
          )}
        </>
      )}
    </Grid>
  );
};

export default TeamPublicView;